import { TOKEN_TIME, TOKEN_TIME_VALUE } from './constant'
// 登陆时设置时间
export const setTokenTime = () => {
  localStorage.setItem(TOKEN_TIME, Date.now())
}
// 获取登录时间
export const getTokenTime = () => {
  return localStorage.getItem(TOKEN_TIME)
}
// 判断token是否过期
export function CheckIsTimeOut() {
  const currentTime = Date.now()
  const tokenTime = getTokenTime()
  return currentTime - tokenTime > TOKEN_TIME_VALUE
}
// 获取cpyNo
export function getcpyNo() {
  return localStorage.getItem('cpyNo')
}
// 验证邮箱的正则表达式
export const checkEmail = (rule, value, cb) => {
  const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  if (regEmail.test(value)) {
    // 合法的邮箱
    return cb()
  }
  cb(new Error('请输入合法的邮箱'))
}
//验证手机号的规则;
export const checkMobile = (rule, value, cb) => {
  // 验证手机号的正则表达式
  const regMobile =
    /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|17[0-9]|18[0-9]|14[0-9]|19[0-9])[0-9]{8}$/
  if (regMobile.test(value)) {
    return cb()
  }
  cb(new Error('请输入合法的手机号'))
}

// 局部时间过滤器
export const dateTime = (timestamp) => {
  let a = new Date(timestamp).getTime()
  const date = new Date(a)
  const Y = date.getFullYear() + '-'
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '  '
  const h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() // 秒
  const dateString = Y + M + D + h + m + s
  // console.log('dateString', dateString); // > dateString 2021-07-06 14:23:00
  return dateString
}
// 局部时间过滤器
export const dateTimes = (timestamp) => {
  let a = new Date(timestamp).getTime()
  const date = new Date(a)
  const Y = date.getFullYear() + '-'
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
  const dateString = Y + M + D
  // console.log('dateString', dateString); // > dateString 2021-07-06
  return dateString
}
export const dateTimesT = (timestamp) => {
  let a = new Date(timestamp).getTime()
  const date = new Date(a)
  const h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() // 秒
  const dateString = h + m + s
  // console.log('dateString', dateString); // > dateString 14:23:00
  return dateString
}
